//从本地初始化用户信息到redux
export const INIT_USERINFO_FROM_LOCAL = 'INIT_USERINFO_FROM_LOCAL';
//登录成功
export const AUTH_LOGIN_OK = 'AUTH_LOGIN_OK';
//退出登录
export const AUTH_LOGOUT_OK = 'AUTH_LOGOUT_OK';
//用户名密码错误
export const AUTH_LOGIN_ERROR = 'LOGIN_WITH_EMAIL_ERROR';
//401鉴权失败，判断弹出登录框
export const AUTH_UNAUTHORIZED = 'AUTH_UNAUTHORIZED';
//更新用户信息
export const AUTH_UPDATE_USER_INFO = 'AUTH_UPDATE_USER_INFO';

// 更新是否显示页脚
export const UPDATE_DISPLAY_FOOTER = 'UPDATE_DISPLAY_FOOTER';
// 更新是否显示页头
export const UPDATE_DISPLAY_HEADER = 'UPDATE_DISPLAY_HEADER';


// 未读消息数
export const UPDATE_UNREAD_NUMBER='UPDATE_UNREAD_NUMBER';
